import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class TpDataExportExcludedItem {
  constructor(item) {
    if (item === undefined) {
      this.TpDataExportExcludedItemId = 0;
      this.EntityType = '';
      this.EntityId = null;
      this.Reason = null;
      this.CreatedOnUtc = null;
      this.ModifiedOnUtc = null;
      this.CreatedBy = null;
      this.ModifiedBy = null;
      this.AdditionalInformation = null;
      this.ThirdPartyInstanceName = null;
      this.Status = null;
      this.Selected = false;
      this.EarlierOccurence = 0;
      return;
    }
    this.TpDataExportExcludedItemId = item.tpDataExportExcludedItemId;
    this.EntityType = item.entityType;
    this.EntityId = item.entityId;
    this.Reason = item.reason;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.CreatedBy = item.createdBy;
    this.ModifiedBy = item.modifiedBy;
    this.AdditionalInformation = item.additionalInformation;
    this.ThirdPartyInstanceName = item.thirdPartyInstanceName;
    this.Status = item.status;
    this.Selected = false;
    this.EarlierOccurence = item.earlierOccurence;
  }

  static displayedInList = 'EntityType';

  static NameOfTheIdField() {
    return 'TpDataExportExcludedItemId';
  }
  static nameOfTheItemDetailList() {
    return 'TpDataExportExcludedItem';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Main',
      tabLabel: 'Main',
      icon: 'fa-solid fa-users',
      data: [
        {
          name: 'TpDataExportExcludedItemId',
          label: 'ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'EntityType', label: 'Entity Type', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'EntityId', label: 'Entity ID', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        {
          name: 'ThirdPartyInstanceName',
          label: 'ThirdPartyInstanceName',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'AdditionalInformation',
          label: 'Info',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'CreatedOnUtc', label: 'Created On', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        {
          name: 'ModifiedOnUtc',
          label: 'Modified On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'CreatedBy', label: 'Created By', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'ModifiedBy', label: 'Modified By', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'Status', label: 'Status', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'Reason', label: 'Reason', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpDataExportExcludedItem.getSelectedCellHeader,
        orderById: '',
        data: TpDataExportExcludedItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'ID',
        orderById: 'TpDataExportExcludedItemId',
        data: 'TpDataExportExcludedItemId',
        minWidth: 30,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Type',
        orderById: 'EntityType',
        data: 'EntityType',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'ID',
        orderById: 'EntityId',
        data: 'EntityId',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Earlier',
        orderById: 'EarlierOccurence',
        data: 'EarlierOccurence',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'TP Instance Name',
        orderById: 'ThirdPartyInstanceName',
        data: 'ThirdPartyInstanceName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Additional Information',
        orderById: 'AdditionalInformation',
        data: (d) => (
          <LongText
            text={d.AdditionalInformation}
            maxLength={60}
          />
        ),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Reason',
        orderById: 'Reason',
        data: (d) => (
          <LongText
            text={d.Reason}
            maxLength={60}
          />
        ),
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Created',
        orderById: 'CreatedOnUtc',
        data: 'CreatedOnUtc',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Modified',
        orderById: 'ModifiedOnUtc',
        data: 'ModifiedOnUtc',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: ' ',
        data: TpDataExportExcludedItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Ignore',
            onClick: () => TpDataExportExcludedItem.ignoreFunction(item.TpDataExportExcludedItemId, item),
            disabled: item.Status !== 'Active',
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Activate',
            onClick: () => TpDataExportExcludedItem.activateFunction(item.TpDataExportExcludedItemId, item),
            disabled: item.Status !== 'Ignored',
          },
        ]}
      />
    );
  }

  static ignoreFunction() {
    alert('Ignore function');
  }

  static activateFunction() {
    alert('Activate function');
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={TpDataExportExcludedItem.selectedStatus()}
          onChange={(e) => {
            TpDataExportExcludedItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            TpDataExportExcludedItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
}
